export default {
  1: "کارتن",
  2: "کیسه",
  3: "پاکت حبابدار",
  4: "جباب پیچ",
  5: "فوم پیچ",
  6: "پاکت",
  7: "پاکت جوف",
  8: "پاکت فلایر",
};
